import React, { Component } from "react";
import { connect } from "react-redux";

class FindPromo extends Component {
  render() {
    return (
      <div
        style={{
          backgroundColor: "#FDCE78",
          marginTop: "50px",
          marginBottom: "50px"
        }}
      >
        <div style={{ display: "inline-block", margin: "20px" }}>
          <h5>Find out your doppelganger now</h5>
          <h6>
            <p>
              Upload your photo and you could see who is your doppelgangger.
            </p>
          </h6>
          <h6>
            <p>You could know who you look alike. Try it now!</p>
          </h6>
          <br />
          <center>
            <p>
              <a href="/search" className="waves-effect waves-light btn blue">
                Get My Twin
              </a>
            </p>
          </center>
        </div>
        <div style={{ display: "inline-block" }}>
          <div
            style={{
              margin: "15px",
              border: "2px dashed white",
              borderColor: "white"
            }}
          >
            <div style={{ display: "inline-block", margin: "20px" }}>
              <img src={require("../assets/girl.png")} alt="you" />
            </div>
            <div style={{ display: "inline-block", margin: "20px" }}>
              <img src={require("../assets/unknown.png")} alt="doppelganger" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(FindPromo);



// WEBPACK FOOTER //
// ./src/components/FindPromo.js